import { buildTrialSignupUrl } from "@marketing-sites/utils/build-trial-signup-url";
import {
  emailFormat,
  maxLength,
  type ValidationRule,
} from "@marketing-sites/utils/validation";

import { EXTERNAL_ROUTES } from "@/constants/external-routes";

/** Opts the landing signup into submitting the steps it already has answers for. */
const SKIP_STEPS_PARAM = "skip_steps";

/** Signup's email field caps the address here; the shared regex has no limit. */
const MAX_EMAIL_LENGTH = 190;

/**
 * The checks an address must pass before it can be handed to signup.
 *
 * Everything these accept, signup accepts: the shared regex is a strict subset
 * of signup's own rule on format, and the cap matches signup's. So a hand-off
 * can never dead-end on validation once the visitor arrives there.
 */
export function handoffEmailValidations(messages: {
  invalid: string;
  tooLong: (max: number) => string;
}): ValidationRule[] {
  return [
    emailFormat(messages.invalid),
    maxLength(MAX_EMAIL_LENGTH, messages.tooLong),
  ];
}

/**
 * The signup URL for a captured address, carrying `skip_steps` so signup submits
 * the email step by itself.
 *
 * `referrer` reproduces what `AddUrlParamsToCrossSiteLinks` appends to the hero's
 * plain CTA. That decorator only rewrites anchors, and this hand-off navigates
 * from a button, so without it the two experiment arms would report different
 * attribution.
 */
export function signupUrlForEmail(email: string, referrer?: string): string {
  const url = new URL(
    buildTrialSignupUrl(EXTERNAL_ROUTES.REACT_SUITE_START_FREE_TRIAL, {
      email,
    }),
  );
  url.searchParams.set(SKIP_STEPS_PARAM, "true");
  if (referrer) url.searchParams.set("utm_referrer", referrer);

  return url.toString();
}
